export default __webpack_public_path__ + "static/media/check-black.47023bda.svg";